import { ApiCallState } from "src/common/ApiCall";
import { useFetchInformationAssetsAccessesApiCallState } from "./information-assets-accesses";
import { useFetchAllResourcesApiCallState } from "./resources";
import { useFetchAllSystemResourcesApiCallState } from "./system-resources";
import { useFetchSystemUserGroupsApiCallState } from "./system-user-group";

export function useFetchApisStatusForInformationAssetsPage() {
  const fetchInformationAssetsAccessesApiCallStatus: ApiCallState =
    useFetchInformationAssetsAccessesApiCallState();
  const fetchInformationSystemUserGroupsApiCallStatus: ApiCallState =
    useFetchSystemUserGroupsApiCallState();
  const fetchAllResourcesApiCallStatus: ApiCallState = useFetchAllResourcesApiCallState();
  const fetchAllSystemResourcesApiCallStatus: ApiCallState =
    useFetchAllSystemResourcesApiCallState();

  function dispatchApiCalls(resetApi: Boolean) {
    fetchInformationAssetsAccessesApiCallStatus.dispatchApiCall(resetApi);
    fetchInformationSystemUserGroupsApiCallStatus.dispatchApiCall(resetApi);
    fetchAllResourcesApiCallStatus.dispatchApiCall(resetApi);
    fetchAllSystemResourcesApiCallStatus.dispatchApiCall(resetApi);
  }

  function areApisCalled() {
    return (
      fetchInformationAssetsAccessesApiCallStatus.isApiCalled &&
      fetchInformationSystemUserGroupsApiCallStatus.isApiCalled &&
      fetchAllResourcesApiCallStatus.isApiCalled &&
      fetchAllSystemResourcesApiCallStatus.isApiCalled
    );
  }

  function areApisCallFailed() {
    return (
      fetchInformationAssetsAccessesApiCallStatus.isApiCallFailed ||
      fetchInformationSystemUserGroupsApiCallStatus.isApiCallFailed ||
      fetchAllResourcesApiCallStatus.isApiCallFailed ||
      fetchAllSystemResourcesApiCallStatus.isApiCallFailed
    );
  }

  function areApisCallLoading() {
    return (
      fetchInformationAssetsAccessesApiCallStatus.isApiCallLoading ||
      fetchInformationSystemUserGroupsApiCallStatus.isApiCallLoading ||
      fetchAllResourcesApiCallStatus.isApiCallLoading ||
      fetchAllSystemResourcesApiCallStatus.isApiCallLoading
    );
  }

  function areApisCallCompletedSuccessfully() {
    return (
      fetchInformationAssetsAccessesApiCallStatus.isApiCallCompletedSuccessfully &&
      fetchInformationSystemUserGroupsApiCallStatus.isApiCallCompletedSuccessfully &&
      fetchAllResourcesApiCallStatus.isApiCalled &&
      fetchAllSystemResourcesApiCallStatus.isApiCalled
    );
  }

  return new ApiCallState(
    areApisCalled(),
    areApisCallFailed(),
    areApisCallLoading(),
    areApisCallCompletedSuccessfully(),
    dispatchApiCalls
  );
}
